<template>
  <div class="progress-bar notification is-info" :class="{ 'is-hidden': isHidden }">
    <strong>{{ title }}</strong><br>

    <div class="is-pulled-right">
      <small v-if="isInitialised">{{ done }}/{{ total }}</small>
      <small v-else>Verwerking wordt gestart...</small>
    </div>

    <progress class="progress" :class="{ 'is-success': isDone }" :value="percentage" max="100">{{ percentage }}%</progress>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Object,
      default: null
    }
  },
  computed: {
    done () {
      return (this.progress) ? this.progress.done : 0
    },
    title () {
      return (this.progress) ? this.progress.title : null
    },
    percentage () {
      return (this.progress) ? (this.progress.done / this.progress.total) * 100 : 0
    },
    total () {
      return (this.progress) ? this.progress.total : 0
    },
    isHidden () {
      return this.progress === null
    },
    isDone () {
      return this.done === this.total
    },
    isInitialised () {
      return this.progress && this.progress.done > 0
    }
  }
}
</script>

<style scoped>
  .progress-bar {
    position: fixed;
    bottom: 15px;
    right: 15px;
    width: 25%;
  }
</style>
